module.exports = __webpack_public_path__ + "static/media/energia.dd6118a1.png";